// extracted by mini-css-extract-plugin
export default {"footer-nav":"inTjbC","footer-nav__wrapper":"fAPdOU","footer-nav__button":"Rj6Pze"};